/**
 * tournaments-matchplay-details.component.ts
 * GolfHubber
 * Created By Manish Naruka 30/03/2020
 * Copyright © 2020 SiyatechVentures.All rights reserved.
 */

import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { ApiService } from "app/services/api";
import { ElasticService } from "app/services/elastic";
import * as lodash from "lodash";
import { environment } from "../../../environments/environment";
import { resolve } from "url";
import { AngularFireDatabase } from "angularfire2/database";
import { OAuthService } from "app/services/o-auth";
import { update } from "lodash";

@Component({
  templateUrl: "./tournaments-matchplay-details.component.html",
  styleUrls: ["./tournaments-matchplay-details.component.scss"],
})
export class TournamentsMatchplayDetailsComponent implements OnInit {
  public loading: boolean = false;
  public manualPlayer: any = {};
  public tournamentId: string;
  public tournament: any = {};
  public club: any;
  public isEdit: boolean;
  public emailMessage: any = "";
  public players: Array<any> = [];
  public query: string;
  public users: Array<any>;
  private typingDelay: any;
  public groups: Array<any> = [];
  public finalGroups: Array<any> = [];
  public selectedPlayers: Array<any> = [];
  public dragNdrop: any = {};
  public searchableGroups: Array<any> = [];
  public shouldConfirm: boolean = false;
  public notificationList: Array<any> = [];
  public emailList: Array<any> = [];
  public notificationMessage: string = "";
  public groupNameEdit: boolean = false;
  public leftTeamName: string = "";
  public rightTeamName: string = "";
  public user: any = {};
  public fieldName: any = "";
  public fieldLabel: any = "";
  public display = "none";
  public display1 = "none";
  public changedHandicapDisplay = "none";
  public playerForHandicapChange: any = {};
  public tabIndex: number = 0;
  public slop_rating = 0;
  public isOpenInviteUserModalNew = false;
  constructor(
    private route: Router,
    private activatedRouter: ActivatedRoute,
    private apiService: ApiService,
    private elasticService: ElasticService,
    private fireDatabase: AngularFireDatabase,
    private oAuthService: OAuthService
  ) {
    this.query = "";
    this.tournamentId = this.activatedRouter.snapshot.paramMap.get("id");
    this.tabIndex = parseInt(
      this.activatedRouter.snapshot.paramMap.get("tabindex")
    );
  }

  trimString(string)
  {
    if(string)
      return string.trim();
    else return ""
  }
  
  async ngOnInit() {
    this.query = "";
    await this.getTournament();
    // await this.getSlopRating();
  }

  async getSlopRating() {
    let st = await this.apiService.object(
      `/tee-slope-ratings/${this.tournament.cid}/${this.tournament.course}/${this.tournament.tee}/verifiedSlopRating`
    );
    this.slop_rating = JSON.parse(JSON.stringify(st)).$value;
  }

  async getTournament() {
    this.tournament = await this.apiService.object(
      `/tournaments/${this.tournamentId}`
    );
    if (this.tournament.slopeRating) {
      this.slop_rating = this.tournament.slopeRating;
    } else {
      this.slop_rating = 113;
    }
    this.user = this.oAuthService.getClub();
    const startTime = parseFloat(this.tournament.startDate) * 1000;
    const endTime = parseFloat(this.tournament.endDate) * 1000;
    const current = new Date().getTime();
    this.leftTeamName = this.tournament.leftTeamName;
    this.rightTeamName = this.tournament.rightTeamName;
    if (current > endTime) {
      this.isEdit = false;
    } else if (startTime > current) {
      const days = Math.floor(
        Math.abs((startTime - current) / (24 * 60 * 60 * 1000))
      );
      if (days < 1) {
        this.isEdit = true;
        this.tournament.status = "Future";
      } else {
        this.isEdit = true;
        this.tournament.status = days + " days to start";
        this.tournament.isDelete = true;
      }
    } else {
      this.tournament.status = "Active";
      this.isEdit = true;
    }

    // this.searchableGroups = [...this.groups];

    let getPlayers = [];
    if (this.tournament.enteries != undefined) {
      if (Object.keys(this.tournament.enteries).length > 0) {
        if (
          this.tournament.type == 2 &&
          this.tournament.organizerType in [0, 1]
        ) {
          let matchplayEnteries = this.tournament["matchplay-enteries"];
          Object.keys(this.tournament.enteries).map((x) => {
            let player = new Promise((resolve) => {
              this.apiService.object(`/users/${x}`).then(function (player) {
                player.key = x;
                player.handicap = matchplayEnteries[x];
                resolve(player);
              });
            });
            getPlayers.push(player);
          });
        } else {
          Object.keys(this.tournament.enteries).map((x) => {
            let player = new Promise((resolve) => {
              this.apiService.object(`/users/${x}`).then(function (player) {
                player.key = x;
                resolve(player);
              });
            });
            getPlayers.push(player);
          });
        }
      }
    }

    let player = await Promise.all(getPlayers);
    player.map((p) => {
      p.isManualPlayer = false;
      this.players.push(p);
      this.selectedPlayers.push(p);
    });
    let uid = this.tournament.userId
      ? this.tournament.userId
      : this.tournament.uid;
    let user = await this.apiService.object("users/" + uid);
    if (!user.$value) {
      user = await this.apiService.object("users/" + this.tournament.uid);
    }
    let profile = await this.apiService.object(
      "user-profiles/" + uid + "/" + this.user.cid
    );
    user.profile = profile;
    this.tournament.user = user;

    //this.selectedPlayers = this.players;
    this.getClub();
    this.getGroups();
    console.log(this.tournament, this.groups);
  }

  async getClub() {
    this.club = await this.apiService.object(`/users/${this.tournament.cid}`);
  }

  formatTime(timestamp) {
    const date = new Date(timestamp * 1000);
    return date.toLocaleString("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: false,
    });
  }

  getHolesPart(): string {
    let part = `All ${this.tournament.holesCount}`;

    if (this.tournament.holesPart === 1) {
      part = "First 9";
    }

    if (this.tournament.holesPart === 2) {
      part = "Last 9";
    }
    return part;
  }

  changeQuery() {
    clearTimeout(this.typingDelay);

    this.typingDelay = setTimeout(() => {
      this.searchMention();
    }, 400);
  }

  searchMention() {
    const queryParams = {
      index: "users",
      type: "user",
      "body/query/bool/must/query_string/query": `${this.query}*`,
      "body/query/bool/must/query_string/fields": ["fullName^10", "username^2"],
    };

    this.elasticService
      .search(queryParams)
      .then((result) => {
        this.users = [];
        if (result && result["hits"]) {
          lodash.forEach(result["hits"], async (item) => {
            const user = lodash.assign({ $key: item["_id"] }, item["_source"]);
            if (
              this.selectedPlayers.findIndex((id) => id.$key == user.$key) == -1
            ) {
              user.isSelected =
                this.selectedPlayers.findIndex((id) => id.$key == user.$key) !=
                -1;
              if (user.$key) {
                user.key = user.$key;
              }
              let firebaseUser = await this.apiService.object(
                `users/${user.key}`
              );
              if (!firebaseUser.deactivated) {
                this.users.push(user);
              }
            }
          });
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  chooseUser(user) {
    if (confirm("Are you sure, you want to add this player?")) {
      user.isManualPlayer = false;
      this.players.push(user);
      var update = {};

      if(+this.tournament.type == 2)
      {
         update[
        `/tournaments/${this.tournamentId}/matchplay-enteries/${user.$key}`
        ] = user.handicap;
      }
      update[
        `/tournament-followings/${this.tournamentId}/followings/${user.$key}`
      ] = null;
      update[`/tournaments/${this.tournamentId}/enteries/${user.$key}`] = true;
      update[
        `/user-tournament-scorecard-appversion/${user.$key}/${this.tournamentId}`
      ] = {
        userType: "2",
        appType: 1,
        versionName: environment.version + "",
        versionCode: environment.version + "",
        platformType: "3",
        osVersion: navigator.platform,
        brandName: navigator.vendor,
        modelName: navigator.userAgent,
        imei: "",
        createdAt: new Date().getTime() / 1000,
      };
      this.apiService
        .bulkUpdate(update)
        .then(() => {
          //$('#invite-users').modal('hide');
          // location.reload()
          this.users = [];
          this.query = "";
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }

  onFocus() {
    this.searchMention();
  }

  onBlur() {
    setTimeout(() => {
      this.users = [];
    }, 500);
  }

  addManualPlayer() {
    if (this.manualPlayer.fullName == undefined) {
      this.manualPlayer.fullNameError = true;
      return;
    }
    if (this.manualPlayer.handicap == undefined) {
      this.manualPlayer.handicapError = true;
      return;
    }
    this.manualPlayer.isManualPlayer = true;
    this.manualPlayer.key = this.apiService.getKey(
      `tournament-fixtures/${this.tournamentId}/`
    );
    this.manualPlayer.handicap = parseFloat(this.manualPlayer.handicap);
    this.manualPlayer["handicapsOriginal"] = parseFloat(this.manualPlayer.handicap);
    this.players.push(this.manualPlayer);
    this.manualPlayer = {};
    document.getElementById("closeModal").click();
  }

  async onClickRandom() {
    let update = {};
    let players: Array<any> = JSON.parse(JSON.stringify(this.players));
    let systemPlayers = players.filter((p) => !p.isManualPlayer);
    let manualPlayers = players.filter((p) => p.isManualPlayer);
    let team = this.tournament.team;
    console.log(systemPlayers, manualPlayers, team);
    let teamCount = parseInt(players.length / (team > 0 ? 4 : 2) + "");
    teamCount =
      teamCount <= systemPlayers.length ? teamCount : systemPlayers.length;
    let teamObj = {};
    if (teamCount <= 0) {
      if (this.tournament.team > 0) {
        alert("Atleast four players are required");
      } else {
        alert("Atleast two players are required");
      }
      return;
    } else {
      for (let t = 0; t < teamCount; t++) {
        let player = JSON.parse(JSON.stringify(systemPlayers[0]));
        if (player.$key) {
          player.key = player.$key;
        }
        teamObj[player.key] = { left: {}, right: {}, all: {} };
        teamObj[player.key].left[player.key] = true;
        teamObj[player.key].all[player.key] = player;
        systemPlayers.splice(0, 1);
      }

      let rightPlayers = manualPlayers.concat(systemPlayers);
      for (let t = 0; t < Object.keys(teamObj).length; t++) {
        let teamId = Object.keys(teamObj)[t];
        let player = JSON.parse(JSON.stringify(rightPlayers[0]));
        teamObj[teamId].right[player.key] = true;
        teamObj[teamId].all[player.key] = player;

        rightPlayers.splice(0, 1);
      }
      if (team > 0) {
        for (let t = 0; t < Object.keys(teamObj).length; t++) {
          let teamId = Object.keys(teamObj)[t];
          let player = JSON.parse(JSON.stringify(rightPlayers[0]));
          teamObj[teamId].left[player.key] = true;
          teamObj[teamId].all[player.key] = player;

          rightPlayers.splice(0, 1);
        }
        for (let t = 0; t < Object.keys(teamObj).length; t++) {
          let teamId = Object.keys(teamObj)[t];
          let player = JSON.parse(JSON.stringify(rightPlayers[0]));
          teamObj[teamId].right[player.key] = true;
          teamObj[teamId].all[player.key] = player;

          rightPlayers.splice(0, 1);
        }
      }
      let finalTeam = {};
      for (let t = 0; t < Object.keys(teamObj).length; t++) {
        let teamId = Object.keys(teamObj)[t];
        let team = teamObj[teamId];
        let matchPlayTeam = [
          {
            leftTeam: true,
            name: "Team Blue",
            owner: teamId,
            players: team.left,
          },
          {
            leftTeam: false,
            name: "Red Blue",
            owner: teamId,
            players: team.right,
          },
        ];
        let handicaps = {};
        let tournamentHandicap = {};
        let manual_players = {};
        for (let a = 0; a < Object.keys(team.all).length; a++) {
          const uid = Object.keys(team.all)[a];
          const user = team.all[uid];
          if (user.fullName) {
            user.name = user.fullName;
          }
          handicaps[uid] = user.handicap;
          tournamentHandicap[uid] = user.handicap;
          if (user.isManualPlayer) {
            manual_players[uid] = user;
          }
        }

        let players: any = {};
        let manualKeys = Object.keys(manual_players);
        let handicapsKeys = Object.keys(tournamentHandicap);
        handicapsKeys.map((h) => {
          let index = manualKeys.findIndex((x) => x == h);
          if (index == -1) {
            players[h] = true;
          }
        });

        if (this.tournament.team == 0) {
          // if singles
          let leftPlayer = Object.keys(team.left)[0];
          let rightPlayer = Object.keys(team.right)[0];
          let temp1 = Math.round(
            (this.slop_rating / 113) * tournamentHandicap[leftPlayer]
          );
          let temp2 = Math.round(
            (this.slop_rating / 113) * tournamentHandicap[rightPlayer]
          );
          if (temp1 > temp2) {
            handicaps[leftPlayer] =
              Math.round(temp1 - temp2) *
              (this.tournament.handicap_percentage / 100);
            handicaps[rightPlayer] = 0;
          } else {
            handicaps[rightPlayer] =
              Math.round(temp2 - temp1) *
              (this.tournament.handicap_percentage / 100);
            handicaps[leftPlayer] = 0;
          }
        } else if (this.tournament.team == 1) {
          // if batterballs
          let leftPlayers = Object.keys(team.left);
          let rightPlayers = Object.keys(team.right);
          let temp1 = Math.round(
            (this.slop_rating / 113) * tournamentHandicap[leftPlayers[0]]
          );
          let temp2 = Math.round(
            (this.slop_rating / 113) * tournamentHandicap[leftPlayers[1]]
          );
          let temp3 = Math.round(
            (this.slop_rating / 113) * tournamentHandicap[rightPlayers[0]]
          );
          let temp4 = Math.round(
            (this.slop_rating / 113) * tournamentHandicap[rightPlayers[1]]
          );
          if (temp1 < temp2 && temp1 < temp3 && temp1 < temp4) {
            let letftone = (temp2 - temp1) * 0.9;
            let rightzero = (temp3 - temp1) * 0.9;
            let rightone = (temp4 - temp1) * 0.9;
            handicaps = {
              [leftPlayers[1]]:
                Math.round(letftone) *
                (this.tournament.handicap_percentage / 100),
              [rightPlayers[0]]:
                Math.round(rightzero) *
                (this.tournament.handicap_percentage / 100),
              [rightPlayers[1]]:
                Math.round(rightone) *
                (this.tournament.handicap_percentage / 100),
              [leftPlayers[0]]: 0,
            };
          } else if (temp2 < temp3 && temp2 < temp4) {
            let leftzero = (temp1 - temp2) * 0.9;
            let rightzero = (temp3 - temp2) * 0.9;
            let rightone = (temp4 - temp2) * 0.9;

            handicaps = {
              [leftPlayers[0]]:
                Math.round(leftzero) *
                (this.tournament.handicap_percentage / 100),
              [rightPlayers[0]]:
                Math.round(rightzero) *
                (this.tournament.handicap_percentage / 100),
              [rightPlayers[1]]:
                Math.round(rightone) *
                (this.tournament.handicap_percentage / 100),
              [leftPlayers[1]]: 0,
            };
          } else if (temp3 < temp4) {
            let leftzero = (temp1 - temp3) * 0.9;
            let leftone = (temp2 - temp3) * 0.9;
            let rightone = (temp4 - temp3) * 0.9;

            handicaps = {
              [leftPlayers[0]]:
                Math.round(leftzero) *
                (this.tournament.handicap_percentage / 100),
              [leftPlayers[1]]:
                Math.round(leftone) *
                (this.tournament.handicap_percentage / 100),
              [rightPlayers[1]]:
                Math.round(rightone) *
                (this.tournament.handicap_percentage / 100),
              [rightPlayers[0]]: 0,
            };
          } else {
            let leftzero = (temp1 - temp4) * 0.9;
            let leftone = (temp2 - temp4) * 0.9;
            let rightzero = (temp3 - temp4) * 0.9;
            handicaps = {
              [leftPlayers[0]]:
                Math.round(leftzero) *
                (this.tournament.handicap_percentage / 100),
              [leftPlayers[1]]:
                Math.round(leftone) *
                (this.tournament.handicap_percentage / 100),
              [rightPlayers[0]]:
                Math.round(rightzero) *
                (this.tournament.handicap_percentage / 100),
              [rightPlayers[1]]: 0,
            };
          }
        } else if (this.tournament.team == 3) {
          // if foursomes
          let leftPlayers = Object.keys(team.left);
          let rightPlayers = Object.keys(team.right);
          let temp1 = Math.round(
            (this.slop_rating / 113) * tournamentHandicap[leftPlayers[0]]
          );
          let temp2 = Math.round(
            (this.slop_rating / 113) * tournamentHandicap[leftPlayers[1]]
          );
          let temp3 = Math.round(
            (this.slop_rating / 113) * tournamentHandicap[rightPlayers[0]]
          );
          let temp4 = Math.round(
            (this.slop_rating / 113) * tournamentHandicap[rightPlayers[1]]
          );
          let leftTeamHandicap = temp1 + temp2;
          let rightTeamHandicap = temp3 + temp4;
          if (leftTeamHandicap < rightTeamHandicap) {
            let rightTeamHandicapFinal =
              Math.round((rightTeamHandicap - leftTeamHandicap) / 2) *
              (this.tournament.handicap_percentage / 100);
            handicaps = {
              [leftPlayers[0]]: 0,
              [leftPlayers[1]]: 0,
              [rightPlayers[0]]: rightTeamHandicapFinal,
              [rightPlayers[1]]: rightTeamHandicapFinal,
            };
          } else {
            let leftTeamHandicapFinal =
              Math.round((leftTeamHandicap - rightTeamHandicap) / 2) *
              (this.tournament.handicap_percentage / 100);
            handicaps = {
              [rightPlayers[0]]: 0,
              [rightPlayers[1]]: 0,
              [leftPlayers[0]]: leftTeamHandicapFinal,
              [leftPlayers[1]]: leftTeamHandicapFinal,
            };
          }
        } else if (this.tournament.team == 4) {
          // id greensomes
          let leftPlayers = Object.keys(team.left);
          let rightPlayers = Object.keys(team.right);
          let temp1 = Math.round(
            (this.slop_rating / 113) * tournamentHandicap[leftPlayers[0]]
          );
          let temp2 = Math.round(
            (this.slop_rating / 113) * tournamentHandicap[leftPlayers[1]]
          );
          let temp3 = Math.round(
            (this.slop_rating / 113) * tournamentHandicap[rightPlayers[0]]
          );
          let temp4 = Math.round(
            (this.slop_rating / 113) * tournamentHandicap[rightPlayers[1]]
          );
          if (temp1 < temp2) {
            handicaps[leftPlayers[0]] = temp1 * 0.6;
            handicaps[leftPlayers[1]] = temp2 * 0.4;
          } else {
            handicaps[leftPlayers[0]] = temp1 * 0.4;
            handicaps[leftPlayers[1]] = temp2 * 0.6;
          }
          let leftTeamHandicap =
            handicaps[leftPlayers[0]] + handicaps[leftPlayers[1]];

          if (temp3 < temp4) {
            handicaps[rightPlayers[0]] = temp3 * 0.6;
            handicaps[rightPlayers[1]] = temp4 * 0.4;
          } else {
            handicaps[rightPlayers[0]] = temp3 * 0.4;
            handicaps[rightPlayers[1]] = temp4 * 0.6;
          }
          let rightTeamHandicap =
            handicaps[rightPlayers[0]] + handicaps[rightPlayers[1]];

          if (leftTeamHandicap < rightTeamHandicap) {
            let rightTeamHandicapFinal =
              Math.round((rightTeamHandicap - leftTeamHandicap) / 2) *
              (this.tournament.handicap_percentage / 100);
            handicaps = {
              [leftPlayers[0]]: 0,
              [leftPlayers[1]]: 0,
              [rightPlayers[0]]: rightTeamHandicapFinal,
              [rightPlayers[1]]: rightTeamHandicapFinal,
            };
          } else {
            let leftTeamHandicapFinal =
              Math.round((leftTeamHandicap - rightTeamHandicap) / 2) *
              (this.tournament.handicap_percentage / 100);
            handicaps = {
              [rightPlayers[0]]: 0,
              [rightPlayers[1]]: 0,
              [leftPlayers[0]]: leftTeamHandicapFinal,
              [leftPlayers[1]]: leftTeamHandicapFinal,
            };
          }
        }

        if (players) {
          for (let key in players) {
            update[`/user-tournaments/${key}/${this.tournamentId}`] =
              key == teamId ? 1 : 4;
          }
        }

        finalTeam[teamId] = {
          matchPlayTeam,
          handicaps,
          manual_players,
          players,
          tournamentHandicap: tournamentHandicap,
          handicapsOriginal: tournamentHandicap,
          name: team.all[teamId].fullName + "'s Team",
          enterStatus: true,
          startHole: 1,
          date: new Date().getTime() / 1000,
          code: this.randomNumber(1000, 9999),
        };
      }
      // console.log(finalTeam, teamCount, rightPlayers, systemPlayers);
      await this.apiService.update(
        "tournament-fixtures/" + this.tournamentId,
        finalTeam
      );

      await this.apiService.bulkUpdate(update);

      this.tabIndex = 2;
      //location.reload();
      if (this.route.url.substring(this.route.url.length - 2) == "/2") {
        location.reload();
      } else {
        this.route.navigateByUrl(
          `components/tournaments-matchplay-details/${this.tournamentId}/${this.tabIndex}`
        );
      }
    }
  }

  async onClickGroupDelete(groupIndex) {
    if (confirm("Are you sure want to delete this team?")) {
      this.groups[groupIndex].leftTeam.map((x) => {
        if (x.$key != undefined) {
          this.players.push(x);
        }
      });
      this.groups[groupIndex].rightTeam.map((x) => {
        if (x.$key != undefined) {
          this.players.push(x);
        }
      });
      let group = this.groups[groupIndex];
      console.log(group.$key);
      let users = { ...group.manual_players, ...group.players };
      if (group.$key) {
        group.key = group.$key;
      }
      if (group.key != undefined) {
        try {
          await this.apiService.set(
            `/tournament-fixtures/${this.tournamentId}/${group.key}`,
            null
          );
          await this.apiService.set(
            `/tournaments/${this.tournamentId}/leaderboard/${group.key}`,
            null
          );
          await this.apiService.set(
            `/tournaments-results/${this.tournamentId}/${group.key}`,
            null
          );
          await this.apiService.set(
            `/tournament-players/${this.tournamentId}/${group.key}`,
            null
          );
          Object.keys(users).map(async (user) => {
            await this.apiService.set(
              `/user-tournaments/${user}/${this.tournamentId}`,
              this.tournament.organizerType == 2 ? 0 : 1
            );
          });
          this.groups.splice(groupIndex, 1);
          this.searchableGroups = [...this.groups];
        } catch (error) {
          console.log(error);
        }
      } else {
        this.searchableGroups.splice(groupIndex, 1);
        this.groups.splice(groupIndex, 1);
      }
    }
  }

  randomNumber(min, max) {
    return Math.floor(Math.random() * (max - min) + min);
  }

  removeEmptyGroups() {
    if (this.tournament.team == 0) {
      this.groups.map((group) => {
        if (
          group.leftTeam[0].$key != undefined &&
          group.rightTeam[0].$key != undefined
        )
          this.finalGroups.push(group);
      });
    } else {
      this.groups.map((group) => {
        if (
          group.leftTeam[0].$key != undefined &&
          group.leftTeam[1].$key != undefined &&
          group.rightTeam[0].$key != undefined &&
          group.rightTeam[1].$key != undefined
        )
          this.finalGroups.push(group);
      });
    }
  }

  // onClickSave() {
  //   // this.loading = true;
  //   let update = {};
  //   let teams = {};
  //   this.removeEmptyGroups();

  //   this.finalGroups.map((finalGroup) => {
  //     let manual_players = {};
  //     let team: any = {};
  //     team.code = Math.floor(1000 + Math.random() * 9000);
  //     team.name = finalGroup.name;
  //     team.startHole = 1;
  //     if (finalGroup.leftTeam[0].isManualPlayer == true)
  //       manual_players[finalGroup.leftTeam[0].$key] = {
  //         name:
  //           finalGroup.leftTeam[0].fullName != undefined
  //             ? finalGroup.leftTeam[0].fullName
  //             : finalGroup.leftTeam[0].name,
  //         handicap: finalGroup.leftTeam[0].handicap,
  //         isManualPlayer: true,
  //       };
  //     if (
  //       this.tournament.team != 0 &&
  //       finalGroup.leftTeam[1].isManualPlayer == true
  //     )
  //       manual_players[finalGroup.leftTeam[1].$key] = {
  //         name:
  //           finalGroup.leftTeam[1].fullName != undefined
  //             ? finalGroup.leftTeam[1].fullName
  //             : finalGroup.leftTeam[1].name,
  //         handicap: finalGroup.leftTeam[1].handicap,
  //         isManualPlayer: true,
  //       };
  //     if (finalGroup.rightTeam[0].isManualPlayer == true)
  //       manual_players[finalGroup.rightTeam[0].$key] = {
  //         name:
  //           finalGroup.rightTeam[0].fullName != undefined
  //             ? finalGroup.rightTeam[0].fullName
  //             : finalGroup.rightTeam[0].name,
  //         handicap: finalGroup.rightTeam[0].handicap,
  //         isManualPlayer: true,
  //       };
  //     if (
  //       this.tournament.team != 0 &&
  //       finalGroup.rightTeam[1].isManualPlayer == true
  //     )
  //       manual_players[finalGroup.rightTeam[1].$key] = {
  //         name:
  //           finalGroup.rightTeam[1].fullName != undefined
  //             ? finalGroup.rightTeam[1].fullName
  //             : finalGroup.rightTeam[1].name,
  //         handicap: finalGroup.rightTeam[1].handicap,
  //         isManualPlayer: true,
  //       };
  //     if (Object.keys(manual_players).length > 0) {
  //       team.manual_players = manual_players;
  //     }

  //     if (this.tournament.team == 3 || this.tournament.team == 4) {
  //       team.matchplayHandicapPercent = this.tournament.handicap_percentage;
  //     }

  //     if (this.tournament.team > 0) {
  //       team.players = {
  //         [finalGroup.leftTeam[0].$key]: true,
  //         [finalGroup.leftTeam[1].$key]: true,
  //         [finalGroup.rightTeam[0].$key]: true,
  //         [finalGroup.rightTeam[1].$key]: true,
  //       };
  //       team.handicaps = {
  //         [finalGroup.leftTeam[0].$key]: finalGroup.leftTeam[0].handicap,
  //         [finalGroup.leftTeam[1].$key]: finalGroup.leftTeam[0].handicap,
  //         [finalGroup.rightTeam[0].$key]: finalGroup.rightTeam[0].handicap,
  //         [finalGroup.rightTeam[1].$key]: finalGroup.rightTeam[1].handicap,
  //       };
  //       team.handicapsOriginal = {
  //         [finalGroup.leftTeam[0].$key]: finalGroup.leftTeam[0].handicap,
  //         [finalGroup.leftTeam[1].$key]: finalGroup.leftTeam[0].handicap,
  //         [finalGroup.rightTeam[0].$key]: finalGroup.rightTeam[0].handicap,
  //         [finalGroup.rightTeam[1].$key]: finalGroup.rightTeam[1].handicap,
  //       };
  //       team.tournamentHandicap = {
  //         [finalGroup.leftTeam[0].$key]: finalGroup.leftTeam[0].handicap,
  //         [finalGroup.leftTeam[1].$key]: finalGroup.leftTeam[0].handicap,
  //         [finalGroup.rightTeam[0].$key]: finalGroup.rightTeam[0].handicap,
  //         [finalGroup.rightTeam[1].$key]: finalGroup.rightTeam[1].handicap,
  //       };
  //       team.matchPlayTeam = {
  //         0: {
  //           leftTeam: true,
  //           name: "Team Red",
  //           owner: finalGroup.leftTeam[0].$key,
  //           players: {
  //             [finalGroup.leftTeam[0].$key]: true,
  //             [finalGroup.leftTeam[1].$key]: true,
  //           },
  //         },
  //         1: {
  //           leftTeam: false,
  //           name: "Team Blue",
  //           owner: finalGroup.leftTeam[0].$key,
  //           players: {
  //             [finalGroup.rightTeam[0].$key]: true,
  //             [finalGroup.rightTeam[1].$key]: true,
  //           },
  //         },
  //       };
  //     } else {
  //       team.players = {
  //         [finalGroup.leftTeam[0].$key]: true,
  //         [finalGroup.rightTeam[0].$key]: true,
  //       };
  //       team.handicaps = {
  //         [finalGroup.leftTeam[0].$key]: finalGroup.leftTeam[0].handicap,
  //         [finalGroup.rightTeam[0].$key]: finalGroup.rightTeam[0].handicap,
  //       };
  //       team.handicapsOriginal = {
  //         [finalGroup.leftTeam[0].$key]: finalGroup.leftTeam[0].handicap,
  //         [finalGroup.rightTeam[0].$key]: finalGroup.rightTeam[0].handicap,
  //       };
  //       team.tournamentHandicap = {
  //         [finalGroup.leftTeam[0].$key]: finalGroup.leftTeam[0].handicap,
  //         [finalGroup.rightTeam[0].$key]: finalGroup.rightTeam[0].handicap,
  //       };
  //       team.matchPlayTeam = {
  //         0: {
  //           leftTeam: true,
  //           name: "Team Red",
  //           owner: finalGroup.leftTeam[0].$key,
  //           players: {
  //             [finalGroup.leftTeam[0].$key]: true,
  //           },
  //         },
  //         1: {
  //           leftTeam: false,
  //           name: "Team Blue",
  //           owner: finalGroup.leftTeam[0].$key,
  //           players: {
  //             [finalGroup.rightTeam[0].$key]: true,
  //           },
  //         },
  //       };
  //     }
  //     teams[finalGroup.$key] = team;
  //   });

  //   update[`tournament-fixtures/${this.tournamentId}/`] = teams;
  //   console.log(update, this.groups);

  //   this.apiService
  //     .bulkUpdate(update)
  //     .then((result) => {
  //       this.loading = false;
  //       // alert("Teams Added");
  //     })
  //     .catch((error) => {
  //       this.loading = false;
  //       console.log(error);
  //     });
  // }

  removePlayer(uid) {
    let index = this.players.findIndex((u) => u.key == uid);
    if (index != -1) {
      this.players.splice(index, 1);
    }
  }

  async getGroups() {
    this.apiService
      .object(`tournament-fixtures/${this.tournamentId}`)
      .then(async (data) => {
        console.log(data.$exists());
        this.groups = [];
        if (
          data != undefined &&
          Object.keys(data).length > 0 &&
          data.$exists()
        ) {
          this.groups = [];
          console.log(this.players);

          for (let t = 0; t < Object.keys(data).length; t++) {
            const teamId = Object.keys(data)[t];
            let team = data[teamId];
            let leftTeam = [];
            let rightTeam = [];

            let manualPlayer = team.manual_players;
            let handicaps = team.handicaps;
            if (team.matchPlayTeam[0] && team.matchPlayTeam[0].players) {
              for (
                let l = 0;
                l < Object.keys(team.matchPlayTeam[0].players).length;
                l++
              ) {
                const leftUid = Object.keys(team.matchPlayTeam[0].players)[l];
                let user: any = {};
                if (manualPlayer && manualPlayer[leftUid]) {
                  user = manualPlayer[leftUid];
                  user.key = leftUid;
                  user.isManualPlayer = true;
                  user.changedHandicap = handicaps[leftUid];
                } else {
                  user = await this.apiService.object("users/" + leftUid);
                  user.changedHandicap = handicaps[leftUid];
                  user.isNotification = false;
                  user.isEmail = false;
                  this.notificationList.push(user);
                  this.emailList.push(user);
                }
                if (user.$key) {
                  user.key = user.$key;
                }
                this.removePlayer(leftUid);
                leftTeam.push(user);
              }
            }
            if (team.matchPlayTeam[1] && team.matchPlayTeam[1].players) {
              for (
                let l = 0;
                l < Object.keys(team.matchPlayTeam[1].players).length;
                l++
              ) {
                const rightUid = Object.keys(team.matchPlayTeam[1].players)[l];
                let user: any = {};
                if (manualPlayer && manualPlayer[rightUid]) {
                  user = manualPlayer[rightUid];
                  user.key = rightUid;
                  user.isManualPlayer = true;
                  user.changedHandicap = handicaps[rightUid];
                } else {
                  user = await this.apiService.object("users/" + rightUid);
                  user.changedHandicap = handicaps[rightUid];
                  user.isNotification = false;
                  user.isEmail = false;
                  this.notificationList.push(user);
                  this.emailList.push(user);
                }
                if (user.$key) {
                  user.key = user.$key;
                }
                this.removePlayer(rightUid);
                rightTeam.push(user);
              }
            }
            team.rightTeam = rightTeam;
            team.leftTeam = leftTeam;
            team.key = teamId;
            this.groups.push(team);
          }
        }
        if (this.isEdit == false) {
          let temp = true;
          while (temp) {
            let i;

            if (this.tournament.team == 0) {
              i = this.groups.findIndex(
                (group) =>
                  group.leftTeam[0].$key == undefined &&
                  group.rightTeam[0].$key == undefined
              );
            } else {
              i = this.groups.findIndex(
                (group) =>
                  group.leftTeam[0].$key == undefined &&
                  group.leftTeam[1].$key == undefined &&
                  group.rightTeam[0].$key == undefined &&
                  group.rightTeam[1].$key == undefined
              );
            }

            if (i == -1) {
              temp = false;
            } else {
              this.groups.splice(i, 1);
            }
          }
        }

        this.searchableGroups = [...this.groups];
        console.log(this.searchableGroups, this.groups);
      });
  }

  checkboxChange1(checked: Boolean) {
    if (checked) {
      this.notificationList.map((list) => {
        list.isNotification = true;
      });
    } else {
      this.notificationList.map((list) => {
        list.isNotification = false;
      });
    }
  }

  checkboxChange2(checked: Boolean) {
    if (checked) {
      this.emailList.map((list) => {
        list.isEmail = true;
      });
    } else {
      this.emailList.map((list) => {
        list.isEmail = false;
      });
    }
  }

  allowDrop(ev) {
    ev.preventDefault();
  }

  drag(ev, groupIndex, teamKey, playersIndex) {
    this.dragNdrop.drag = {
      groupIndex: groupIndex,
      teamKey: teamKey,
      playersIndex: playersIndex,
    };
  }

  dragPlayers(ev, key) {
    this.dragNdrop.drag = {
      key: key,
      groupIndex: -1,
    };
  }

  async drop(ev, groupIndex, teamKey, playersIndex) {
    this.dragNdrop.drop = {
      groupIndex: groupIndex,
      teamKey: teamKey,
      playersIndex: playersIndex,
      handicaps: {},
    };
    ev.preventDefault();
    await this.changePositions();
  }

  async changePositions() {
    if (
      this.groups[this.dragNdrop.drop.groupIndex][this.dragNdrop.drop.teamKey][
        this.dragNdrop.drop.playersIndex
      ].$key == undefined
    ) {
      if (this.dragNdrop.drag.groupIndex == -1) {
        let playerIndex = this.players.findIndex(
          (x) => x.$key == this.dragNdrop.drag.key
        );
        // console.log(playerIndex, this.players[playerIndex]);
        let movingUser: any = this.players[playerIndex];
        movingUser.changedHandicap = movingUser.handicap;
        if (movingUser.$key) {
          movingUser.key = movingUser.$key;
        }
        if (
          this.groups[this.dragNdrop.drop.groupIndex].$key == undefined &&
          movingUser.isManualPlayer
        ) {
          alert("First Player of Team should not be a manual player!");
        } else {
          this.groups[this.dragNdrop.drop.groupIndex][
            this.dragNdrop.drop.teamKey
          ][this.dragNdrop.drop.playersIndex] = movingUser;
          this.players.splice(playerIndex, 1);
          if (
            this.groups[this.dragNdrop.drop.groupIndex].$key == undefined &&
            this.groups[this.dragNdrop.drop.groupIndex].key == undefined &&
            !movingUser.isManualPlayer
          ) {
            this.groups[this.dragNdrop.drop.groupIndex].$key = movingUser.key;
            this.groups[this.dragNdrop.drop.groupIndex].key = movingUser.key;
            this.groups[this.dragNdrop.drop.groupIndex].code = Math.floor(
              1000 + Math.random() * 9000
            );
            this.groups[this.dragNdrop.drop.groupIndex].startHole = 1;
            this.groups[this.dragNdrop.drop.groupIndex].name =
              movingUser.fullName + "'s Team";
          }
          if (!this.groups[this.dragNdrop.drop.groupIndex].handicaps) {
            this.groups[this.dragNdrop.drop.groupIndex].handicaps = {};
          }
          this.groups[this.dragNdrop.drop.groupIndex].handicaps[
            movingUser.key
          ] = movingUser.handicap;

          if (!this.groups[this.dragNdrop.drop.groupIndex].tournamentHandicap) {
            this.groups[this.dragNdrop.drop.groupIndex].tournamentHandicap = {};
          }
          this.groups[this.dragNdrop.drop.groupIndex].tournamentHandicap[
            movingUser.key
          ] = movingUser.handicap;

          if (!this.groups[this.dragNdrop.drop.groupIndex].manual_players) {
            this.groups[this.dragNdrop.drop.groupIndex].manual_players = {};
          }
          if (movingUser.isManualPlayer == true) {
            this.groups[this.dragNdrop.drop.groupIndex].manual_players[
              movingUser.key
            ] = {
              name: movingUser.name ? movingUser.name : movingUser.fullName,
              handicap: movingUser.handicap,
              isManualPlayer: true,
            };
          }
          if (!this.groups[this.dragNdrop.drop.groupIndex].players) {
            this.groups[this.dragNdrop.drop.groupIndex].players = {};
          }
          if (!movingUser.isManualPlayer) {
            this.groups[this.dragNdrop.drop.groupIndex].players[
              movingUser.key
            ] = true;
          }

          console.log(this.groups);
          // await this.saveChanges(
          //   this.groups[this.dragNdrop.drop.groupIndex],
          //   movingUser
          // );
          if (movingUser.$key) {
            movingUser.key = movingUser.$key;
          }
          if (this.tournament.team > 0) {
            if (
              this.groups[this.dragNdrop.drop.groupIndex].leftTeam[0].key !=
                undefined &&
              this.groups[this.dragNdrop.drop.groupIndex].leftTeam[1].key !=
                undefined &&
              this.groups[this.dragNdrop.drop.groupIndex].rightTeam[0].key !=
                undefined &&
              this.groups[this.dragNdrop.drop.groupIndex].rightTeam[1].key !=
                undefined
            ) {
              this.saveChanges(this.groups[this.dragNdrop.drop.groupIndex]);
            }
          } else {
            if (
              this.groups[this.dragNdrop.drop.groupIndex].leftTeam[0].key !=
                undefined &&
              this.groups[this.dragNdrop.drop.groupIndex].rightTeam[0].key !=
                undefined
            ) {
              this.saveChanges(this.groups[this.dragNdrop.drop.groupIndex]);
            }
          }
        }
      } else {
        let movingUser: any = this.groups[this.dragNdrop.drag.groupIndex][
          this.dragNdrop.drag.teamKey
        ][this.dragNdrop.drag.playersIndex];
        if (
          this.groups[this.dragNdrop.drop.groupIndex].$key == undefined &&
          this.groups[this.dragNdrop.drop.groupIndex].$key == undefined &&
          movingUser.isManualPlayer
        ) {
          alert("First Player of Team should not be a manual player!");
        } else {
          this.groups[this.dragNdrop.drag.groupIndex][
            this.dragNdrop.drag.teamKey
          ][this.dragNdrop.drag.playersIndex] = {};
          this.groups[this.dragNdrop.drop.groupIndex][
            this.dragNdrop.drop.teamKey
          ][this.dragNdrop.drop.playersIndex] = movingUser;
        }
      }
    }
    this.searchableGroups = [...this.groups];
  }

  groupNameChange(group) {
    if (
      group.name == undefined ||
      group.name == null ||
      group.name == "" ||
      group.name == " "
    ) {
      alert("Team name can not be blank!");
      group.name = "Team-1";
    }
  }

  async saveChanges(group) {
    let team: any = {};
    const temp = { ...group.handicaps };
    team.code = group.code;
    team.handicaps = group.handicaps;
    team.handicapsOriginal = { ...temp };
    team.name = group.name;
    team.startHole = 1;
    team.tournamentHandicap = group.tournamentHandicap;
    team.manual_players = group.manual_players ? group.manual_players : null;
    team.players = group.players;
    team.key = group.$key ? group.$key : group.key;

    let matchplayTeam: any = {};
    let leftTeam: any = {};
    leftTeam["owner"] = group.$key ? group.$key : group.key;
    leftTeam["leftTeam"] = true;
    leftTeam["name"] = "Red Team";
    leftTeam["players"] = {};
    let rightTeam: any = {};
    rightTeam["owner"] = group.$key ? group.$key : group.key;
    rightTeam["leftTeam"] = false;
    rightTeam["name"] = "Blue Team";
    rightTeam["players"] = {};

    group.leftTeam.map((l) => {
      leftTeam.players[l.key] = true;
    });
    group.rightTeam.map((r) => {
      rightTeam.players[r.key] = true;
    });
    matchplayTeam["0"] = leftTeam;
    matchplayTeam["1"] = rightTeam;
    team.matchPlayTeam = matchplayTeam;

    if (this.tournament.team == 0) {
      // if single
      let leftPlayer = Object.keys(leftTeam["players"])[0];
      let rightPlayer = Object.keys(rightTeam["players"])[0];
      let temp1 = Math.round(
        (this.slop_rating / 113) * team.tournamentHandicap[leftPlayer]
      );
      let temp2 = Math.round(
        (this.slop_rating / 113) * team.tournamentHandicap[rightPlayer]
      );
      if (temp1 > temp2) {
        team.handicaps[leftPlayer] =
          Math.round(temp1 - temp2) *
          (this.tournament.handicap_percentage / 100);
        team.handicaps[rightPlayer] = 0;
      } else {
        team.handicaps[rightPlayer] =
          Math.round(temp2 - temp1) *
          (this.tournament.handicap_percentage / 100);
        team.handicaps[leftPlayer] = 0;
      }
    } else if (this.tournament.team == 1) {
      // if batterballs
      let leftPlayers = Object.keys(leftTeam["players"]);
      let rightPlayers = Object.keys(rightTeam["players"]);
      let temp1 = Math.round(
        (this.slop_rating / 113) * team.tournamentHandicap[leftPlayers[0]]
      );
      let temp2 = Math.round(
        (this.slop_rating / 113) * team.tournamentHandicap[leftPlayers[1]]
      );
      let temp3 = Math.round(
        (this.slop_rating / 113) * team.tournamentHandicap[rightPlayers[0]]
      );
      let temp4 = Math.round(
        (this.slop_rating / 113) * team.tournamentHandicap[rightPlayers[1]]
      );
      if (temp1 < temp2 && temp1 < temp3 && temp1 < temp4) {
        let leftone = (temp2 - temp1) * 0.9;

        let rightzero = (temp3 - temp1) * 0.9;

        let rightone = (temp4 - temp1) * 0.9;
        team.handicaps = {
          [leftPlayers[1]]:
            Math.round(leftone) * (this.tournament.handicap_percentage / 100),
          [rightPlayers[0]]:
            Math.round(rightzero) * (this.tournament.handicap_percentage / 100),
          [rightPlayers[1]]:
            Math.round(rightone) * (this.tournament.handicap_percentage / 100),
          [leftPlayers[0]]: 0,
        };
      } else if (temp2 < temp3 && temp2 < temp4) {
        let leftzero = (temp1 - temp2) * 0.9;
        let rightzero = (temp3 - temp2) * 0.9;
        let rightone = (temp4 - temp2) * 0.9;

        team.handicaps = {
          [leftPlayers[0]]:
            Math.round(leftzero) * (this.tournament.handicap_percentage / 100),
          [rightPlayers[0]]:
            Math.round(rightzero) * (this.tournament.handicap_percentage / 100),
          [rightPlayers[1]]:
            Math.round(rightone) * (this.tournament.handicap_percentage / 100),
          [leftPlayers[1]]: 0,
        };
      } else if (temp3 < temp4) {
        let leftzero = (temp1 - temp3) * 0.9;
        let rightone = (temp4 - temp3) * 0.9;
        let leftone = (temp2 - temp3) * 0.9;

        team.handicaps = {
          [leftPlayers[0]]:
            Math.round(leftzero) * (this.tournament.handicap_percentage / 100),
          [leftPlayers[1]]:
            Math.round(leftone) * (this.tournament.handicap_percentage / 100),
          [rightPlayers[1]]:
            Math.round(rightone) * (this.tournament.handicap_percentage / 100),
          [rightPlayers[0]]: 0,
        };
      } else {
        let leftzerp = (temp1 - temp4) * 0.9;
        let leftone = (temp2 - temp4) * 0.9;
        let rightzero = (temp3 - temp4) * 0.9;

        team.handicaps = {
          [leftPlayers[0]]:
            Math.round(leftzerp) * (this.tournament.handicap_percentage / 100),
          [leftPlayers[1]]:
            Math.round(leftone) * (this.tournament.handicap_percentage / 100),
          [rightPlayers[0]]:
            Math.round(rightzero) * (this.tournament.handicap_percentage / 100),
          [rightPlayers[1]]: 0,
        };
      }
    } else if (this.tournament.team == 3) {
      // if foursomes
      let leftPlayers = Object.keys(leftTeam["players"]);
      let rightPlayers = Object.keys(rightTeam["players"]);
      let temp1 = Math.round(
        (this.slop_rating / 113) * team.tournamentHandicap[leftPlayers[0]]
      );
      let temp2 = Math.round(
        (this.slop_rating / 113) * team.tournamentHandicap[leftPlayers[1]]
      );
      let temp3 = Math.round(
        (this.slop_rating / 113) * team.tournamentHandicap[rightPlayers[0]]
      );
      let temp4 = Math.round(
        (this.slop_rating / 113) * team.tournamentHandicap[rightPlayers[1]]
      );
      let leftTeamHandicap = temp1 + temp2;
      let rightTeamHandicap = temp3 + temp4;
      if (leftTeamHandicap < rightTeamHandicap) {
        let rightTeamHandicapFinal =
          Math.round((rightTeamHandicap - leftTeamHandicap) / 2) *
          (this.tournament.handicap_percentage / 100);
        team.handicaps = {
          [leftPlayers[0]]: 0,
          [leftPlayers[1]]: 0,
          [rightPlayers[0]]: rightTeamHandicapFinal,
          [rightPlayers[1]]: rightTeamHandicapFinal,
        };
      } else {
        let leftTeamHandicapFinal =
          Math.round((leftTeamHandicap - rightTeamHandicap) / 2) *
          (this.tournament.handicap_percentage / 100);
        team.handicaps = {
          [rightPlayers[0]]: 0,
          [rightPlayers[1]]: 0,
          [leftPlayers[0]]: leftTeamHandicapFinal,
          [leftPlayers[1]]: leftTeamHandicapFinal,
        };
      }
    } else if (this.tournament.team == 4) {
      // id greensomes
      let leftPlayers = Object.keys(leftTeam["players"]);
      let rightPlayers = Object.keys(rightTeam["players"]);
      let temp1 = Math.round(
        (this.slop_rating / 113) * team.tournamentHandicap[leftPlayers[0]]
      );
      let temp2 = Math.round(
        (this.slop_rating / 113) * team.tournamentHandicap[leftPlayers[1]]
      );
      let temp3 = Math.round(
        (this.slop_rating / 113) * team.tournamentHandicap[rightPlayers[0]]
      );
      let temp4 = Math.round(
        (this.slop_rating / 113) * team.tournamentHandicap[rightPlayers[1]]
      );
      if (temp1 < temp2) {
        team.handicaps[leftPlayers[0]] = temp1 * 0.6;
        team.handicaps[leftPlayers[1]] = temp2 * 0.4;
      } else {
        team.handicaps[leftPlayers[0]] = temp1 * 0.4;
        team.handicaps[leftPlayers[1]] = temp2 * 0.6;
      }
      let leftTeamHandicap =
        team.handicaps[leftPlayers[0]] + team.handicaps[leftPlayers[1]];

      if (temp3 < temp4) {
        team.handicaps[rightPlayers[0]] = temp3 * 0.6;
        team.handicaps[rightPlayers[1]] = temp4 * 0.4;
      } else {
        team.handicaps[rightPlayers[0]] = temp3 * 0.4;
        team.handicaps[rightPlayers[1]] = temp4 * 0.6;
      }
      let rightTeamHandicap =
        team.handicaps[rightPlayers[0]] + team.handicaps[rightPlayers[1]];

      if (leftTeamHandicap < rightTeamHandicap) {
        let rightTeamHandicapFinal =
          Math.round((rightTeamHandicap - leftTeamHandicap) / 2) *
          (this.tournament.handicap_percentage / 100);
        team.handicaps = {
          [leftPlayers[0]]: 0,
          [leftPlayers[1]]: 0,
          [rightPlayers[0]]: rightTeamHandicapFinal,
          [rightPlayers[1]]: rightTeamHandicapFinal,
        };
      } else {
        let leftTeamHandicapFinal =
          Math.round((leftTeamHandicap - rightTeamHandicap) / 2) *
          (this.tournament.handicap_percentage / 100);
        team.handicaps = {
          [rightPlayers[0]]: 0,
          [rightPlayers[1]]: 0,
          [leftPlayers[0]]: leftTeamHandicapFinal,
          [leftPlayers[1]]: leftTeamHandicapFinal,
        };
      }
    }

    await this.apiService.update(
      "tournament-fixtures/" + this.tournamentId + "/" + team.key,
      team
    );
    console.log(group);
    let update = {};
    if (team.players) {
      for (let key in team.players) {
        update[`/user-tournaments/${key}/${this.tournamentId}`] =
          key == team.key ? 1 : 4;
      }
    }
    await this.apiService.bulkUpdate(update);
    this.tabIndex = 2;
    //location.reload();
    if (this.route.url.substring(this.route.url.length - 2) == "/2") {
      location.reload();
    } else {
      this.route.navigateByUrl(
        `components/tournaments-matchplay-details/${this.tournamentId}/${this.tabIndex}`
      );
    }
  }

  makeRound(number) {
    return Math.round(number);
  }

  onClickPLayerDelete(groupIndex, teamKey, playersIndex) {
    if (confirm("Are you sure want to remove this player?")) {
      let movingUser: any = this.groups[groupIndex][teamKey][playersIndex];
      this.groups[groupIndex][teamKey][playersIndex] = {};
      this.players.push(movingUser);
      let update = {};

      update[
        `/tournament-fixtures/${this.tournamentId}/${
          this.groups[groupIndex].key
        }/matchPlayTeam/${teamKey === "leftTeam" ? 0 : 1}/players/${
          movingUser.key
        }`
      ] = null;
      update[
        `/tournament-fixtures/${this.tournamentId}/${this.groups[groupIndex].key}/handicaps/${movingUser.key}`
      ] = null;
      update[
        `/tournament-fixtures/${this.tournamentId}/${this.groups[groupIndex].key}/handicapsOriginal/${movingUser.key}`
      ] = null;
      update[
        `/tournament-fixtures/${this.tournamentId}/${this.groups[groupIndex].key}/tournamentHandicap/${movingUser.key}`
      ] = null;

      if (movingUser.isManualPlayer) {
        update[
          `/tournament-fixtures/${this.tournamentId}/${this.groups[groupIndex].key}/manual_players/${movingUser.key}`
        ] = null;
      } else {
        update[
          `/tournament-fixtures/${this.tournamentId}/${this.groups[groupIndex].key}/players/${movingUser.key}`
        ] = null;
      }
      console.log(update);

      this.apiService
        .bulkUpdate(update)
        .then((data) => console.log(data))
        .catch((error) => console.log(error));

      this.searchableGroups = [...this.groups];
    }
  }

  onAddTeamClick() {
    if (this.tournament.team == 0) {
      this.groups.push({
        name: `Team-`,
        leftTeam: [{}],
        rightTeam: [{}],
      });
    } else {
      this.groups.push({
        name: `Team-`,
        leftTeam: [{}, {}],
        rightTeam: [{}, {}],
      });
    }
    this.searchableGroups = [...this.groups];
  }

  canDeactivate(): Promise<boolean> | boolean {
    if (this.shouldConfirm)
      return confirm(
        "Are you sure you want to continue? Any unsaved changes will be lost."
      );
    else return true;
  }

  search(event) {
    console.log(event.target.value);
    this.searchableGroups = this.groups.filter((group) =>
      group.name.toUpperCase().includes(event.target.value.toUpperCase())
    );
  }

  onTabClick(ev) {
    if (ev === 2 && this.isEdit == true) {
      this.shouldConfirm = true;
    } else {
      this.shouldConfirm = false;
    }
  }

  sendNotification() {
    let users = {};
    this.notificationList.map((notification) => {
      if (notification.isNotification) {
        users[notification.$key] = true;
      }
    });

    let body = {
      title: "Matchplay",
      body: this.notificationMessage,
      type: 19,
      cid: this.tournament.cid,
      tournament: this.tournamentId,
    };

    let notifications = {};
    this.notificationList.map((notification) => {
      notifications[
        `server-process/admin-notification/${notification.$key}/${this.tournament.userId}`
      ] = body;
    });

    this.apiService
      .bulkUpdate(notifications)
      .then((data) => alert("Notification Sent"))
      .catch((error) => console.log(error));
  }

  sendEmail() {
    let users = {};
    this.emailList.map((email) => {
      if (email.isEmail) {
        users[email.$key] = true;
      }
    });

    let body = {
      subject: "Matchplay",
      text: this.emailMessage,
      users: { ...users },
    };

    let notifications = {};
    this.notificationList.map((notification) => {
      notifications[`server-process/admin-send-custom-email/`] = body;
    });

    this.apiService
      .bulkUpdate(notifications)
      .then((data) => alert("Email Sent"))
      .catch((error) => console.log(error));
  }

  onGroupNameEditClick(i) {
    document.getElementById("span-" + i).style.display = "none";
    document.getElementById("input-" + i).style.display = "block";
    document.getElementById("edit-" + i).style.display = "none";
    document.getElementById("check-" + i).style.display = "block";
  }

  async onGroupNameSaveClick(i, group) {
    document.getElementById("span-" + i).style.display = "block";
    document.getElementById("input-" + i).style.display = "none";
    document.getElementById("edit-" + i).style.display = "block";
    document.getElementById("check-" + i).style.display = "none";

    if (
      group.name == undefined ||
      group.name == null ||
      group.name == "" ||
      group.name == " "
    ) {
      alert("Team name can not be blank!");
      group.name = "Team-1";
    } else if (confirm("Are you sure want to change this team name?")) {
      if (group.key != undefined) {
        try {
          await this.apiService.set(
            `/tournament-fixtures/${this.tournamentId}/${group.key}/name`,
            group.name
          );
        } catch (error) {
          console.error(error);
        }
      }
    }
  }

  async onClickPlayerDelete1(player) {
    console.log(player);
    if (confirm("Are you sure want to remove this player?..")) {
      if (!player.isManualPlayer) {
        let update = {};
        let index = this.players.findIndex((x) => x.$key == player.$key);
        update[
          `/tournament-followings/${this.tournamentId}/followings/${player.$key}`
        ] = null;
        update[
          `/tournaments/${this.tournamentId}/enteries/${player.$key}`
        ] = null;
        if (+this.tournament.type == 2 && (this.tournament.organizerType == 0 || this.tournament.organizerType == 1))
      {
          update[
            `/tournaments/${this.tournamentId}/matchplay-enteries/${player.$key}`
          ] = null;
        }
        update[
          `/user-tournament-scorecard-appversion/${player.$key}/${this.tournamentId}`
        ] = null;

        update[
        `/tournaments/${this.tournamentId}/matchplay-enteries/${player.$key}`
        ] = null;
        try {
          await this.apiService.bulkUpdate(update);
          this.players.splice(index, 1);
        } catch (error) {
          console.log(error);
        }
      } else {
        let index = this.players.findIndex((x) => x.key == player.key);
        this.players.splice(index, 1);
      }
    }
  }

  public onChange(event, type) {
    // console.log(event);
    switch (type) {
      case 1:
        this.apiService.set(
          `/tournaments/${this.tournamentId}/isFixtureShow`,
          event.checked
        );

        break;

      case 2:
        this.apiService.set(
          `/tournaments/${this.tournamentId}/isLast3ScoreHide`,
          event.checked
        );

        break;
    }
  }

  async changeTeamName(name, type, id) {
    switch (type) {
      case 1:
        await this.apiService.set(
          `/tournaments/${this.tournamentId}/leftTeamName`,
          name
        );
        this.tournament.leftTeamName = name;
        document.getElementById(id).click();
        break;
      case 2:
        await this.apiService.set(
          `/tournaments/${this.tournamentId}/rightTeamName`,
          name
        );
        this.tournament.rightTeamName = name;
        document.getElementById(id).click();
        break;
    }
  }

  openManualPlayerModal() {
    this.display = "block";
    $("#exampleModal").modal("show");
  }

  setUpModal(type) {
    this.fieldName = type;
    this.fieldLabel = type == 1 ? "Left Team Name" : "Right Team Name";
    this.display1 = "block";
    $("#exampleModal2").modal("show");
  }

  openChangePlayerHandicapModal(groupIndex, teamKey, playersIndex) {
    if (this.isEdit == false) return;
    this.changedHandicapDisplay = "block";
    let player: any = this.groups[groupIndex][teamKey][playersIndex];

    let tournamentHandicap = this.groups[groupIndex].tournamentHandicap[
      player.key
    ];

    this.playerForHandicapChange = {
      groupIndex: groupIndex,
      teamKey: teamKey,
      playersIndex: playersIndex,
      player: player,
      name: player.name ? player.name : player.fullName,
      handicap: player.handicap,
      changedHandicap: player.changedHandicap,
      tournamentHandicap: tournamentHandicap.toFixed(2),
    };
    $("#changePlayerHandicapModal").modal("show");
  }

  onClickChangeHandicap() {
    let player = this.groups[this.playerForHandicapChange.groupIndex][
      this.playerForHandicapChange.teamKey
    ][this.playerForHandicapChange.playersIndex];

    this.groups[this.playerForHandicapChange.groupIndex].tournamentHandicap[
      player.key
    ] = this.playerForHandicapChange.tournamentHandicap;

    this.groups[this.playerForHandicapChange.groupIndex].handicapsOriginal[
      player.key
    ] = this.playerForHandicapChange.tournamentHandicap;

    this.groups[
      this.playerForHandicapChange.groupIndex
    ].handicaps = this.groups[
      this.playerForHandicapChange.groupIndex
      ].handicapsOriginal;
    
    if (
      this.groups[this.playerForHandicapChange.groupIndex].leftTeam[0].key !=
        undefined &&
      this.groups[this.playerForHandicapChange.groupIndex].rightTeam[0].key !=
        undefined
    ) {
      this.saveChanges(this.groups[this.playerForHandicapChange.groupIndex]);
    }
    $("#changePlayerHandicapModal").modal("hide");
  }

  async printToCart() {
    let monthArray = [
      "Jan",
      "Feb",
      "March",
      "April",
      "May",
      "June",
      "July",
      "Aug",
      "Sept",
      "Oct",
      "Nov",
      "Dec",
    ];

    let d = new Date(parseInt(this.tournament.startDate));

    let date =
      d.getDate() + "-" + monthArray[d.getMonth()] + "-" + d.getFullYear();

    let popupWinindow;
    const innerContents = document.getElementById("convertableData").innerHTML;
    popupWinindow = window.open(
      "",
      "_blank",
      "width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no"
    );
    popupWinindow.document.open();
    popupWinindow.document.write(
      `<html><head><style>
      html, body {
        color : white,
        background-color : #2c333b
      }
      input{border : none ; background : none}
      .image-action-containeer {
        height: 350px;
        width: 100%;
        display: flex;
        flex-direction: column;
        margin-top: 20px;
        padding-right: 30px;
        .image-container {
          flex: 5;
          overflow: hidden;
          img {
            height: 100%;
            width: 100%;
          }
        }
        .actions-container {
          flex: 1;
          padding-top: 10px;
        }
      }

      .info-container {
        .row {
          .col-md-6 {
            padding: 10px;
            div {
              padding: 5px 20px;
              background-color: #2c333b;
            }
          }
        }
      }

      .tournament-and-club-details-container {
        overflow-x: hidden;
        .user-info {
          padding: 20px;
          min-height: auto;
          text-align: left;
          background-color: #2c333b;
        }
        .course {
          padding: 20px;
        }
        .course-info {
          padding: 20px;
          background-color: #2c333b;
        }
      }

      .team-search-input {
        width: 50%;
        background-color: none;
        color: white;
        border: 1px solid whitesmoke;
      }

      .matchplay-team-row {
        margin-top: 15px;
        padding-top: 15px;
        background-color: #2c333b;
        padding-bottom: 15px;
      }

      .teams-container {
        width: 100%;
        display: flex;
        flex-direction: column;
        padding-top: 20px;
      }

.teams-header {
  width: 100%;
  display: flex;
  border-radius: 10px;
}

.blue-teams-header {
  height: 50px;
  flex: 1;
  background-color: blue;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  border-bottom-right-radius: 10px;
  border-top-right-radius: 10px;
}
.red-teams-header {
  height: 50px;
  flex: 1;
  background-color: red;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  border-bottom-left-radius: 10px;
  border-top-left-radius: 10px;
}

      .teams-body {
        width: 100%;

        display: flex;
        flex-direction: column;
      }
      .team-details-contaienr {
        background-color: #25282a;
        display: flex;
        flex-direction: column;
        border-radius: 10px;
        padding: 10px;

      }

      .team-name {
        width: 100%;
       }
      .team-name span {
        margin-left: 10px !important;
        float: left;
      }
      .team-name input {
        margin-left: 10px !important;
        border: none;
        display: none;
        float: left;
      }

      .teams {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-around;
      }

.custom-badge {
  border: none;
  outline: none !important;
  color: #fff;
  display: inline-block;
  font-size: 75%;
  font-weight: bold;
  color: #fff;
  text-align: center;
  border-radius: 60px;
  padding: 6px 16px;
  font-weight: 500;
  white-space: nowrap;
  vertical-align: baseline;
}
      .blue-team {
        flex-basis: 46%;
        padding: 10px 10px 0px 0px;
      }

      .blue-member-1 {
        background: #2c333b;
        height: 45px;
        border-radius: 10px;
        box-shadow: 0px 1px 1px blue;
      }

      .blue-member-2 {
        background: #2c333b;
        height: 45px;
        border-radius: 10px;
        box-shadow: 0px 1px 1px blue;
        margin-top: 15px;
      }

      .vs {
        flex-basis: 6%;
        font-size: 15px;
        text-align: center;
        background: #4fb860;
        padding: 5px 0px 5px 0px;
        border-radius: 50%;
        font-weight: bolder;
        color : white;
      }

      .dragable-object {

        padding-left: 10px;
        padding-right: 10px;
        height: 100%;
        width: 90%;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      .red-team {
        flex-basis: 46%;
        padding: 10px 0px 0px 10px;
      }

      .red-member-1 {
        background: #2c333b;
        height: 45px;
        border-radius: 10px;
        box-shadow: 0px 1px 1px red;
      }

      .red-member-2 {
        background: #2c333b;
        height: 45px;
        border-radius: 10px;
        box-shadow: 0px 1px 1px red;
        margin-top: 15px;
      }
      </style></head><body onload="window.print()">
      <div style="display:flex; flex-direction: column">
      <p>Event Name : ${this.tournament.eventName}</p>
      <div style="display:flex; justify-content:space-between">
      <p>Start Date : ${date}</p>
      <p>Start Time : ${this.tournament.startTime}</p>
      </div>
      </div>
      ${innerContents} </html>`
    );
    popupWinindow.document.close();
  }

   validateHandicapRequired()
    {
        
        let returnVal;


        let globalRegex=new RegExp("^([-]{0,1})([1-9]{1,2}|[1-9]{1,1}[0-9]{1,1})([.]{1}[0-9]{1})?$") ;

        let regExTest = globalRegex.test(this.manualPlayer.handicap)
        if (regExTest && !isNaN(parseFloat(this.manualPlayer.handicap)) && parseFloat(this.manualPlayer.handicap) >= -10.9 && parseFloat(this.manualPlayer.handicap) <= 54.9 && this.manualPlayer.handicap.length <6)
        {
            returnVal = false;
        }
        else
        {
            returnVal =  true;
        }
        return returnVal;
        
        // if(this.selectedUser.handicap.length<1 || this.selectedUser.handicap == null || typeof this.selectedUser.handicap === undefined)

    }
  
  validateOnlyHandicap(event)
    {
    if(
        event.keyCode == 8 || //backspace
        event.keyCode == 37 || //left arrow
        event.keyCode == 39 || //right arrow
        event.keyCode == 46 || //delete
        event.keyCode == 189 || //-
        event.keyCode == 190 || //.
        event.keyCode == 109 || //- numLock
        event.keyCode == 110 || //. numLock
        (event.keyCode >= 48 && event.keyCode <= 57) ||
        (event.keyCode >= 96 && event.keyCode <= 105)
        ) {
        return true;
        }
        return false;
  }

  choosePlayer(event) {
    let item = event.player;
    item.user = event.player;
    this.chooseUser(item);
    $("#invite-users-new").modal('hide');
  }

  openInviteUserModalNew(event)
  {
    this.isOpenInviteUserModalNew = true;
    $("#invite-users-new").modal('show');
  }
}
